import { useMemo } from 'react';
import { Spinner } from '../ui';
import ViewTrigger from '../view-trigger';
import EndOfFeed from './end-of-feed';
import { DEFAULT_SKIP_TO_CONTENT_ID } from '../skip-to-content/skip-to-content';
import { Content } from '../../models/content/types';
import EmptyFeed from './empty-feed';
import {
  FeedCardGrid,
  FeedCardGridItem,
} from '@socialchorus/shared-ui-components';
import {
  FeedCardWithData,
  FeedCardProps,
} from '../content/solar-feed-card/solar-feed-card';

type FeedProps = {
  items: Content[];
  page: number;
  fetching: boolean;
  titleHeadingLevel: FeedCardProps['titleHeadingLevel'];
  canLoadMore: boolean;
  fetchFeed: () => void;
  analyticsData: IAnalyticsData;
  emptyFeed?: JSX.Element;
};

const Feed = ({
  items,
  page,
  fetching: isFetching,
  titleHeadingLevel,
  canLoadMore,
  fetchFeed,
  analyticsData,
  emptyFeed = <EmptyFeed />,
}: FeedProps) => {
  const classes = 'feed-v2';

  const renderContentItems = useMemo(
    () => (
      <FeedCardGrid columns={1}>
        {items.map((content) => (
          <FeedCardGridItem key={content.id}>
            <FeedCardWithData
              content={content}
              analyticsData={analyticsData}
              compact={true}
              layout="horizontal"
              titleHeadingLevel={titleHeadingLevel}
            />
          </FeedCardGridItem>
        ))}
      </FeedCardGrid>
    ),
    [items, titleHeadingLevel, analyticsData]
  );

  return (
    <section className={classes} id={DEFAULT_SKIP_TO_CONTENT_ID}>
      {page ? renderContentItems : null}
      {isFetching ? (
        <Spinner />
      ) : canLoadMore ? (
        <ViewTrigger offset="600px" onInview={() => fetchFeed()} />
      ) : items.length ? (
        <EndOfFeed />
      ) : (
        emptyFeed
      )}
    </section>
  );
};

export default Feed;
